import {
  BEIJING_HERO_IMG,
  DEST_IMGS,
  SCANDCQ_HERO_IMG,
  SICHUAN_HERO_IMG,
  XIAN_HERO_IMG,
} from "./destinationAssets";

/** 导航地区 key */
export const REGION_KEYS = ["sichuan", "chongqing", "beijing", "xian"];

/** 各地区对应的线路 id（destinationDetail.list 下标） */
export const REGION_TOUR_IDS = {
  sichuan: [0, 1],
  chongqing: [1],
  beijing: [2],
  xian: [3],
};

export const REGION_HERO_IMGS = {
  sichuan: SICHUAN_HERO_IMG,
  chongqing: SCANDCQ_HERO_IMG,
  beijing: BEIJING_HERO_IMG,
  xian: XIAN_HERO_IMG,
};

export const REGION_CARD_IMGS = {
  sichuan: DEST_IMGS[0],
  chongqing: DEST_IMGS[1],
  beijing: DEST_IMGS[2],
  xian: DEST_IMGS[3],
};

export function isValidRegion(region) {
  return REGION_KEYS.includes(region);
}

export function getRegionTourIds(region) {
  return REGION_TOUR_IDS[region] || [];
}
